/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, isVariable } from '../../../../Fct/generics/FctParams';
import { FaArrowRight } from 'react-icons/fa';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var TransferFrom = createPlugin({
    protocol: 'ERC20',
    type: 'ACTION',
    method: 'transferFrom',
    falseMeansFail: true,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                    isPreview: true,
                    icon: FaArrowRight
                }),
                methodParams: {
                    from: new FctAddress({}),
                    to: new FctAddress({ isPreview: true, }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true, }),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params, _chainId, _walletAddress, vaultAddress, _p, _m, isEstimation) {
        var to = params.to, _a = params.methodParams, from = _a.from, amount = _a.amount;
        if (!vaultAddress)
            return [];
        var address = from.value;
        if (vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase())
            return [];
        var value = amount.value;
        if (isEstimation && isVariable(value) && typeof amount.estimatedValue === 'string') {
            value = amount.estimatedValue;
        }
        if (!value)
            return [];
        return [
            {
                to: to.value,
                from: from.value,
                params: { spender: vaultAddress, amount: value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
